import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import Auth from "./components/Auth";
import MainLayout from "@/layouts/MainLayout";
import NotFound from "./components/NotFound";
import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";
import { UserProvider } from "./context/UserContext";
import { ThemeProvider } from "./context/ThemeProvider";
import { Toaster } from "@/components/ui/sonner";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Lazy load route components
const WaitlistPage = lazy(() => import("./pages/WaitlistPage"));
const InvestorDashboard = lazy(
  () => import("./pages/investor/Dashboard/InvestorDashboard")
);
const Crates = lazy(() => import("./pages/investor/crates/ExploreCrates"));
const CrateView = lazy(() => import("./pages/investor/crates/ViewCrate"));
const EditCrate = lazy(() => import("./pages/investor/crates/EditCrate/Page"));

// Loading component
const PageLoader = () => (
  <div className="flex items-center justify-center h-screen">
    <Loader2 className="animate-spin mr-2 size-8" />
  </div>
);

const App = () => {
  return (
    <>
      <Router>
        <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
          <GoogleOAuthProvider clientId="466166715128-g3qdmonrsithnmvr4v932iptikfao2kh.apps.googleusercontent.com">
            <UserProvider>
              <Routes>
                <Route path="/waitlist" element={<WaitlistPage />} />
                <Route path="/auth" element={<Auth />} />
                <Route
                  path="/"
                  element={<Navigate to="/dashboard" replace />}
                />
                <Route element={<MainLayout />}>
                  <Route
                    path="/dashboard"
                    element={
                      <Suspense fallback={<PageLoader />}>
                        <InvestorDashboard />
                      </Suspense>
                    }
                  />
                  <Route
                    path="/crates/view"
                    element={
                      <Suspense fallback={<PageLoader />}>
                        <Crates />
                      </Suspense>
                    }
                  />
                  <Route
                    path="/crates/view/:id"
                    element={
                      <Suspense fallback={<PageLoader />}>
                        <CrateView />
                      </Suspense>
                    }
                  />
                  <Route
                    path="/crates/edit/:id"
                    element={
                      <Suspense fallback={<PageLoader />}>
                        <EditCrate />
                      </Suspense>
                    }
                  />
                </Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </UserProvider>
          </GoogleOAuthProvider>
          <Toaster position="top-center" richColors={true} />
        </ThemeProvider>
      </Router>
    </>
  );
};

export default App;
